import { Slice } from "@reduxjs/toolkit";
import { createGenericSlice } from "../../explorer/redux/storeUtils";

import { Site } from "../../explorer/types/SpareParts/Site";
import { Brand } from "../../explorer/types";
import { Basket } from "../../explorer/types";
import {
  Label,
  Language,
  NavigationState,
  UserInfo,
} from "../../explorer/types";
import { Machine } from "../../explorer/types/SpareParts";
import { PartDetailsProps } from "../components/PartDetails/PartDetailsProps";
import { defaultLanguage } from "./defaultSettings";
import { AppInfo } from "../../explorer/types/System/AppInfo";
import React from "react";

/*
  ===== REDUX CONFIGURATION =====
*/

/* aggiungere gli state per le parti comuni */
/* usare questa sintassi:
    sliceName: createGenericSlice<S>(sliceName: string, initialState: GenericState<S>),
    NB: tipizzare correttamente l'oggetto commonState aggiungendo sliceName: Slice 
*/
const systemState: {
  systemAppInfo: Slice;
  //systemLanguages: Slice;
  systemLabels: Slice;
  systemNavigationState: Slice;
  //systemBrands: Slice;
  systemUserInfo: Slice;
  systemError: Slice;
  systemApiError: Slice;
  systemApiNotification: Slice;
  systemApiPersistNotification: Slice;
  systemApiWarning: Slice;
} = {
  systemAppInfo: createGenericSlice<AppInfo>("systemAppInfo", {
    value: {},
  }),
  // systemLanguages: createGenericSlice<Language[]>("systemLanguages", {
  //   value: [],
  // }),
  systemLabels: createGenericSlice<Label[]>("systemLabels", { value: [] }),
  systemNavigationState: createGenericSlice<NavigationState>(
    "systemNavigationState",
    { value: { lang: defaultLanguage } }
  ),
  // systemBrands: createGenericSlice<Brand[]>("systemBrands", { value: [] }),
  systemUserInfo: createGenericSlice<UserInfo>("systemUserInfo", {
    value: { userType: "", userName: "", email: "" },
  }),
  systemError: createGenericSlice<string>("systemError", { value: "" }),
  systemApiError: createGenericSlice<string | undefined>("systemApiError", { value: undefined }),
  systemApiNotification: createGenericSlice<string | undefined>("systemApiNotification", { value: undefined }),
  systemApiPersistNotification: createGenericSlice<string | undefined>("systemApiPersistNotification", { value: undefined }),
  systemApiWarning: createGenericSlice<string | React.JSX.Element | undefined>("systemApiWarning", { value: undefined }),
};

const sparePartsState: {
  sparePartsfamilies: Slice;
  sparePartsSites: Slice;
  sparePartsCurrentSite: Slice;
  sparePartsSearchLayout: Slice;
  sparePartsCurrentMachine: Slice;
  sparePartsCurrentNaturalKey: Slice;
  sparePartsPartDetails: Slice;
} = {
  sparePartsfamilies: createGenericSlice<[]>("sparePartsfamilies", {
    value: [],
  }),
  sparePartsSites: createGenericSlice<Site[]>("sparePartsSites", {
    value: [],
  }),
  sparePartsCurrentSite: createGenericSlice<Site>("sparePartsCurrentSite", {
    value: {},
  }),
  sparePartsSearchLayout: createGenericSlice<string>("sparePartsSearchLayout", {
    value: "G",
  }),
  sparePartsCurrentMachine: createGenericSlice<Machine>("sparePartsCurrentMachine", {
    value: {},
  }),
  sparePartsCurrentNaturalKey: createGenericSlice<string>("sparePartsCurrentNaturalKey", {
    value: "",
  }),
  sparePartsPartDetails: createGenericSlice<PartDetailsProps>("sparePartsPartDetails", {
    value: { open: false },
  }),
};

const basketState: {
  basketBaskets: Slice;
  basketCurrentBasket: Slice;
} = {
  basketBaskets: createGenericSlice<Basket[]>("basketBaskets", { value: [] }),
  basketCurrentBasket: createGenericSlice<Basket>("basketCurrentBasket", {
    value: {},
  })
};

export const reduxStoreConfig: typeof systemState &
  typeof sparePartsState &
  typeof basketState = {
  ...systemState,
  ...sparePartsState,
  ...basketState,
};
